import { DASHBOARD_I18N_EN } from './dashboardKeys';

export default {
  'nav.progress': 'Progress',
  'nav.home': 'Home',
  'nav.calculator': 'Calculator',
  'nav.foods': 'Foods',
  'nav.myaccount': 'My Account',
  'nav.foodsmanager': 'Food Master',
  'nav.plans': 'Plans',
  'nav.users': 'Users',
  'nav.admin': 'Admin',
  'nav.companies': 'Companies',
  'nav.equivalentes': 'Equivalents',
  'nav.recipes': 'Recipes',
  'auth.logout': 'Log Out',
  'auth.login': 'Sign In',
  'auth.logging_in': 'Signing in...',
  'auth.welcome': 'Welcome to',
  'auth.email': 'Email',
  'auth.email_placeholder': 'you@email.com',
  'auth.password': 'Password',
  'auth.remember_me': 'Remember me',
  'auth.login_error': 'Login error',
  'auth.no_account': "Don't have an account?",
  'auth.register_free': 'Register for free',
  'welcome.title': 'Welcome, {name}!',
  'welcome.role': 'Role',
  'card.calculator.title': '🧮 Nutrition Calculator',
  'card.calculator.desc': 'Calculate your personalized plan from your data',
  'card.calculator.button': 'Open Calculator',
  'card.admin.title': '⚙️ Administration',
  'card.admin.desc': 'Manage calculator concepts',
  'card.admin.button': 'Admin Panel',
  'card.users.title': '👥 Users & Roles',
  'card.users.desc': 'Review and adjust user roles',
  'card.users.button': 'Open Users',
  'card.plans.title': '🧾 Subscription Plans',
  'card.plans.desc': 'Create, edit and delete plans',
  'card.plans.button': 'Manage Plans',
  'card.companies.title': '🏢 Companies',
  'card.companies.desc': 'View gyms, trainers and assigned users',
  'card.companies.button': 'Open Companies',
  'card.myplan.title': '📊 My Plan',
  'card.myplan.desc': 'View your personalized nutrition plan',
  'card.myplan.button': 'View Plan',
  'card.foodlog.title': '🍔 Food Log',
  'card.foodlog.desc': 'Log what you ate today',
  'card.foodlog.button': 'Add Meal',
  'card.progress.title': '📈 Progress',
  'card.progress.desc': 'Visualize your evolution',
  'card.progress.button': 'View Stats',
  'card.equivalentes.title': '🔄 Equivalents by Group',
  'card.equivalentes.desc': 'Swap foods keeping macros',
  'card.equivalentes.button': 'View Equivalents',
  'card.recipes.title': '📚 Recipes',
  'card.recipes.desc': 'Explore healthy recipes',
  'card.recipes.button': 'Open Recipes',
  'home.summary.title': 'Day Summary',
  'calculator.title': 'Nutrition Calculator',
  'calculator.subtitle': 'Calculate your personalized plan',
  'calculator.age': 'Age (years)',
  'calculator.weight': 'Weight (kg)',
  'calculator.height': 'Height (cm)',
  'calculator.gender': 'Gender',
  'calculator.male': 'Male',
  'calculator.female': 'Female',
  'calculator.activity': 'Activity Level',
  'calculator.goal': 'Goal',
  'calculator.maintenance': 'Maintenance',
  'calculator.fatloss': 'Fat Loss',
  'calculator.muscle': 'Muscle Gain',
  'calculator.calculate': 'Calculate Plan',
  'calculator.calculating': 'Calculating...',
  'calculator.result_title': 'Your Personalized Plan',
  'calculator.daily_calories': 'Daily Calories',
  'calculator.protein': 'Protein',
  'calculator.carbs': 'Carbs',
  'calculator.fats': 'Fats',
  'calculator.tmb': 'BMR',
  'calculator.tdee': 'TDEE',
  'myaccount.current_subscription': 'My Current Subscription',
  'myaccount.no_active': 'You have no active subscription.',
  'myaccount.expires': 'Expires',
  'myaccount.gym': 'Gym',
  'myaccount.trainer': 'Trainer',
  'myaccount.sessions_left': 'Sessions Left',
  'myaccount.mydata': 'My Data',
  'myaccount.birthdate': 'Birthdate',
  'myaccount.objective': 'Goal',
  'myaccount.save': 'Save Changes',
  'myaccount.available_plans': 'Available Plans',
  'myaccount.choose_plan': 'Choose your plan',
  'myaccount.subscribe': 'Subscribe',
  'myaccount.subscribe_plan': 'Subscribe Plan',
  'myaccount.method': 'Payment Method',
  'myaccount.confirm_and_pay': 'Confirm and Pay',
  'myaccount.confirm': 'Confirm',
  'recipes.library_title': '📚 Recipe Library',
  'recipes.search_ph': 'Search recipes (e.g. Chicken, Keto...)',
  'recipes.search': 'Search',
  'recipes.loading': 'Loading recipes...',
  'recipes.none': 'No recipes found.',
  'recipes.view': 'View Details',
  'recipes.ai_button': '🤖 AI Chef',
  'recipes.ai_title': '👨‍🍳 Smart Chef',
  'recipes.ai_type': 'Meal Type',
  'recipes.ai_ingredients': 'Available ingredients (comma separated)',
  'recipes.ai_prefs': 'Preferences / Restrictions',
  'recipes.ai_generate': '✨ Generate Recipe',
  'recipes.ai_cooking': '🍳 Cooking idea...',
  'recipes.import_replace': 'Replace library',
  'recipes.import_add': 'Add',
  'recipes.import_help': 'Paste a table with columns: ID Receta, Nombre del Plato, Ingredientes Clave (IDs), Cal Totales, Proteína T, Carbos T, Grasas T. Sections like "--Desayunos...---ID Receta..." are allowed.',
  'recipes.import_ph': 'Paste recipes here...',
  'recipes.import_parse_error': '❌ No valid recipe rows found.',
  'recipes.import_done': '✅ Recipes replaced',
  'recipes.import_done_add': '✅ Recipes added',
  'recipes.import_error': '❌ Error importing recipes',
  'recipes.add_link_title': 'Add recipe link',
  'recipes.link_name': 'Name',
  'recipes.link_url': 'URL',
  'recipes.link_tags': 'Tags (comma separated)',
  'recipes.add_link': 'Add',
  'lang.label': 'Language',
  'lang.es': 'Spanish',
  'lang.en': 'English',
  'admin.menu.users': 'Users',
  'admin.menu.plans': 'Plans',
  'admin.menu.gyms': 'Gyms',
  'admin.menu.trainers': 'Trainers',
  'admin.menu.foods': 'Foods',
  'admin.menu.calculator': 'Calculator',
  'admin.menu.payments': 'Payments',
  'admin.menu.companies': 'Companies',
  'admin.subtitle': 'Manage {section} and system settings.',
  'admin.view_site': 'View Website',
  'common.loading': 'Loading...',
  'common.search': 'Search',
  'common.user': 'User',
  'common.role': 'Role',
  'common.plan': 'Plan',
  'common.close': 'Close',
  'common.name': 'Name',
  'common.email': 'Email',
  'common.email_ph': 'john@example.com',
  'common.create': 'Create',
  'common.cancel': 'Cancel',
  'common.none': 'None',
  'common.registration': 'Registration',
  'common.back': '← Back',
  'common.saving': 'Saving...',
  'common.city': 'City',
  'common.address': 'Address',
  'common.contact': 'Contact',
  'common.actions': 'Actions',
  'common.select': 'Select...',
  'common.change': 'Change',
  'common.fullname': 'Full Name',
  'common.fullname_ph': 'e.g. John Smith',
  'common.phone': 'Phone',
  'common.phone_ph': '+1 555 123 4567',
  'common.name_required': 'Name *',
  'common.description': 'Description',
  'common.gym': 'Gym',
  'common.trainer': 'Trainer',
  'common.save': 'Save',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.id': 'ID',
  'meals.breakfast': 'Breakfast',
  'meals.lunch': 'Lunch',
  'meals.dinner': 'Dinner',
  'meals.snack': 'Snack',
  'groups.all': 'All',
  'groups.protein': 'Proteins',
  'groups.carbs': 'Carbs',
  'groups.fats': 'Fats',
  'foods.view_more': 'View more foods',
  'foods.scan': 'Scan',
  'foods.stop_scan': 'Stop',
  'foods.quick_create': 'Quick create food',
  'foods.create_food': 'Create food',
  'foods.serving_ph': 'Serving (e.g. 100)',
  'foodlog.title': 'Food Log',
  'foodlog.subtitle': 'Add your meals and track your goals',
  'foodlog.nutrition_plan': 'Nutrition Plan',
  'foodlog.range_title': 'Date Range',
  'foodlog.start': 'Start',
  'foodlog.end': 'End',
  'foodlog.weekly_progress': 'Weekly Progress',
  'foodlog.no_range': 'No data for the range.',
  'foodlog.date': 'Date',
  'foodlog.summary_btn': 'Food summary',
  'foodlog.select_meal': 'Select meal',
  'foodlog.assign_food': 'Assign food',
  'foodlog.base_portion': 'Base portion',
  'foodlog.portions': 'Portions (integers)',
  'foodlog.meal': 'Meal',
  'foodlog.equals': 'Equals to',
  'foodlog.add_to_log': 'Add to log',
  'foodlog.no_records_meal': 'No records for this meal',
  'foodlog.no_records_in': 'No records in',
  'foodlog.deleted_ok': '✅ Entry deleted',
  'foodlog.delete_error': '❌ Error deleting entry',
  'foodlog.delete_confirm': 'Are you sure you want to delete this entry?',
  'foodlog.portion_integer_error': 'Portion must be an integer greater than 0',
  'foodlog.added_ok': '✅ Food added',
  'foodlog.save_error': '❌ Error saving entry',
  'foodlog.barcode_found': '✅ Product found by barcode',
  'foodlog.barcode_not_found': '❌ Product not found. You can create it quickly here.',
  'foods.scan_unsupported': 'Scanner not supported in this browser. Use the code input.',
  'foods.scan_error': 'Error reading code. Try again.',
  'foods.camera_denied': 'Could not access the camera. Check permissions.',
  'foods.created_ok': '✅ Food created',
  'foods.create_error': '❌ You lack permissions or data is incomplete',
  'foods.form_required': '❌ Please complete all required fields',
  'foods.updated_ok': '✅ Food updated successfully',
  'foods.save_error': '❌ Error saving food',
  'foods.delete_confirm': 'Are you sure you want to delete this food?',
  'foods.deleted_ok': '✅ Food deleted successfully',
  'foods.delete_error': '❌ Error deleting food',
  'foods.bulk_delete_no_code': 'Delete without code',
  'foods.bulk_delete_confirm': 'Delete all foods without a barcode?',
  'foods.bulk_delete_done': 'Bulk delete completed',
  'foods.bulk_delete_hint': 'Removes entries without barcode',
  'foods.bulk_none': 'There are no foods without a code.',
  'foods.import_replace': 'Replace catalog',
  'foods.import_add': 'Add',
  'foods.import_replace_hint': 'Replace catalog by pasting a table',
  'foods.import_help': 'Paste a table with columns: Barcode, Food, Category, Cal, Prot, Carb, Fats. Default serving 100 g.',
  'foods.import_ph': 'Paste data here...',
  'foods.import_parse_error': '❌ No valid rows found. Check the format.',
  'foods.import_done': '✅ Import completed',
  'foods.import_done_add': '✅ Data added',
  'foods.import_error': '❌ Error importing foods',
  'companies.error_loading': 'Error loading data',
  'companies.gyms': 'Gyms',
  'companies.trainers': 'Trainers',
  'companies.no_gyms': 'No gyms',
  'companies.no_trainers': 'No trainers',
  'companies.users_of_gym': 'Gym Users: {name}',
  'companies.users_of_trainer': 'Trainer Users: {name}',
  'companies.select_prompt': 'Select a gym or trainer',
  'companies.new_user': 'New user',
  'companies.password_optional': 'Password (optional)',
  'companies.no_plan': 'No plan',
  'companies.no_assigned': 'No assigned users',
  'users.title': 'Users',
  'users.subtitle': 'Manage users and system settings.',
  'users.tabs.users': 'Users',
  'users.tabs.gyms': 'Gyms',
  'users.tabs.trainers': 'Trainers',
  'users.new_user': 'New User',
  'users.edit_user': 'Edit User',
  'users.create_user': 'Create New User',
  'users.error_loading': 'Error loading users',
  'users.loading': 'Loading users...',
  'users.none': 'No users registered.',
  'users.none_search': 'No results match your search.',
  'users.search_ph': 'Search by name, email, ID, role, gym or coach...',
  'users.search_aria': 'Search people',
  'users.list_title': 'People list',
  'users.search_count': '{shown} of {total}',
  'users.total_count': '{total} registered',
  'users.email_exists': 'This email is already registered',
  'users.gyms_summary': 'Gyms Summary',
  'users.trainers_summary': 'Trainers Summary',
  'users.view_users': 'View users',
  'users.no_assigned': 'No assigned users.',
  'users.new_password_prompt': 'New password (min. 6 characters):',
  'users.password_min': 'Password must be at least 6 characters',
  'users.password_updated': 'Password updated',
  'users.password_update_error': 'Error updating password',
  'users.reset_password': 'Reset password',
  'users.reset_password_short': 'Reset Pass',
  'users.delete_confirm': 'Are you sure you want to delete this user?',
  'users.delete_error': 'Error deleting user',
  'calculator.admin.title': 'Calculator Concepts Management',
  'calculator.admin.subtitle': 'Activity factors and rules for calculation.',
  'calculator.toggle_add': '+ Add Concept',
  'calculator.toggle_cancel': 'Cancel',
  'calculator.form.name': 'Name',
  'calculator.form.type': 'Type',
  'calculator.form.select_type': 'Select type',
  'calculator.form.value': 'Value',
  'calculator.form.description': 'Description',
  'calculator.type.activity': 'Activity Factor',
  'calculator.type.macro': 'Macro Distribution',
  'calculator.type.other': 'Other',
  'calculator.saving': 'Saving...',
  'calculator.create': 'Create',
  'calculator.update': 'Update',
  'calculator.table.name': 'Name',
  'calculator.table.type': 'Type',
  'calculator.table.value': 'Value',
  'calculator.table.description': 'Description',
  'calculator.table.actions': 'Actions',
  'calculator.edit': 'Edit',
  'calculator.delete': 'Delete',
  'calculator.created': 'Concept created',
  'calculator.updated': 'Concept updated',
  'calculator.deleted': 'Concept deleted',
  'calculator.delete_confirm': 'Delete this concept?',
  'calculator.save_error': 'Error saving concept',
  'plans.subscription': 'Subscription Plan',
  'plans.title': 'Subscription Plans',
  'plans.new': 'New Plan',
  'plans.edit': 'Edit Plan',
  'plans.create': 'Create New Plan',
  'plans.name': 'Plan Name',
  'plans.monthly_price': 'Monthly Price (COP)',
  'plans.max_users': 'Max Users',
  'plans.features': 'Features (separated by comma)',
  'plans.features_ph': 'e.g. 24/7 Access, Personal Trainer',
  'plans.save': 'Save Plan',
  'plans.price': 'Price',
  'plans.capacity': 'Capacity',
  'plans.active': 'Active',
  'plans.loading': 'Loading plans...',
  'plans.none': 'No plans available. Create a new one.',
  'plans.error_loading': 'Error loading plans',
  'plans.delete_confirm': 'Are you sure you want to delete this plan?',
  'plans.delete_error': 'Error deleting plan',
  'gyms.error_loading': 'Error loading gyms',
  'gyms.updated': 'Gym updated successfully',
  'gyms.created': 'Gym created successfully',
  'gyms.save_error': 'Error saving gym',
  'gyms.delete_confirm': 'Are you sure you want to delete this gym?',
  'gyms.deleted': 'Gym deleted successfully',
  'gyms.delete_error': 'Error deleting gym',
  'gyms.plan_assigned': 'Plan assigned successfully',
  'gyms.assign_error': 'Error assigning plan',
  'gyms.title': 'Gym Management',
  'gyms.subtitle': 'Manage branches and locations',
  'gyms.new': 'New Gym',
  'gyms.search_ph': 'Search by name, city or address...',
  'gyms.edit': 'Edit Gym',
  'gyms.create': 'Create New Gym',
  'gyms.name': 'Gym Name',
  'gyms.name_ph': 'e.g. Smart Fit Center',
  'gyms.city_ph': 'e.g. Bogotá',
  'gyms.address_ph': 'e.g. 123 Main St',
  'gyms.contact_email': 'Contact Email',
  'gyms.email_ph': 'e.g. contact@gym.com',
  'gyms.loading': 'Loading gyms...',
  'gyms.none': 'No gyms found',
  'gyms.none_help': 'Try adjusting your search or create a new gym.',
  'gyms.location': 'Location',
  'trainers.error_loading': 'Error loading trainers',
  'trainers.save_error': 'Error saving trainer',
  'trainers.delete_confirm': 'Are you sure you want to delete this trainer?',
  'trainers.delete_error': 'Error deleting trainer',
  'trainers.title': 'Trainer Management',
  'trainers.subtitle': 'Manage trainers and their assignments',
  'trainers.new': 'New Trainer',
  'trainers.edit': 'Edit Trainer',
  'trainers.list': 'Trainers List',
  'trainers.search_ph': 'Search trainer...',
  'trainers.trainer': 'Trainer',
  'trainers.specialty': 'Specialty',
  'trainers.specialty_ph': 'e.g. Strength, Yoga, Crossfit',
  'trainers.assigned_gym': 'Assigned Gym',
  'trainers.select_gym': 'Select a gym',
  'trainers.save': 'Save Trainer',
  'trainers.loading': 'Loading trainers...',
  'trainers.none': 'No trainers found',
  'trainers.general': 'General',
  'trainers.gym_id': 'Gym ID: ',
  'trainers.unassigned': 'Unassigned',
  'trainers.showing': 'Showing {shown} of {total} trainers',
  'foods.title': 'Food Master Management',
  'foods.subtitle': 'Manage the food catalog and nutrition values.',
  'foods.new': 'New Food',
  'foods.edit': 'Edit Food',
  'foods.create': 'Create New Food',
  'foods.name_ph': 'e.g. Chicken Breast',
  'foods.barcode': 'Barcode',
  'foods.barcode_ph': 'Scan or type code...',
  'foods.category_required': 'Category *',
  'foods.select_category': 'Select category',
  'foods.brand': 'Brand',
  'foods.brand_ph': 'e.g. Generic',
  'foods.amount_required': 'Amount *',
  'foods.unit_required': 'Unit *',
  'foods.unit_g': 'Grams (g)',
  'foods.unit_ml': 'Milliliters (ml)',
  'foods.unit_unidad': 'Unit',
  'foods.unit_tbsp': 'Tablespoon',
  'foods.unit_cup': 'Cup',
  'foods.nutrients_title': 'Nutrition Per Serving',
  'foods.calories': 'Calories',
  'foods.protein': 'Protein (g)',
  'foods.carbs': 'Carbs (g)',
  'foods.fats': 'Fats (g)',
  'foods.search_ph': 'Search food...',
  'foods.all_categories': 'All categories',
  'foods.code': 'Code',
  'foods.food': 'Food',
  'foods.category': 'Category',
  'foods.serving': 'Serving',
  'foods.cal': 'Cal',
  'foods.protein_short': 'Protein',
  'foods.carbs_short': 'Carbs',
  'foods.fats_short': 'Fats',
  'foods.generic': 'Generic',
  'foods.none': 'No foods found',
  'foods.total': 'Total:',
  'foods.items': 'items',
  'progress.title': 'Progress',
  'progress.subtitle': 'Tracking and recommendations',
  'progress.kpis': 'Range KPIs',
  'progress.avg_adherence': 'Average adherence',
  'progress.avg_calories': 'Average Calories',
  'progress.avg_protein': 'Average Protein',
  'progress.avg_carbs': 'Average Carbs',
  'progress.avg_fats': 'Average Fats',
  'progress.range_filters': 'Range & Filters',
  'progress.start': 'Start',
  'progress.end': 'End',
  'progress.gym': 'Gym',
  'progress.trainer': 'Trainer',
  'progress.all': 'All',
  'progress.by_day': 'Progress by Day',
  'progress.no_data_range': 'No data in the range.',
  'progress.quick_summary': 'Quick Summary',
  'progress.days_in_range': 'Days in range',
  'progress.agg': 'Aggregates',
  'progress.selected_gym': 'Selected Gym',
  'progress.selected_trainer': 'Selected Trainer',
  'progress.kcal_in_range': 'kcal in range',
  'progress.analytics_groups': 'Group Analytics',
  'progress.gyms': 'Gyms',
  'progress.trainers': 'Trainers',
  'progress.export_both': 'Export both CSV',
  'progress.page_size': 'Page size',
  'progress.gym_name_ph': 'Gym name',
  'progress.trainer_name_ph': 'Trainer name',
  'progress.clear': 'Clear',
  'progress.export_csv': 'Export CSV',
  'progress.compliance_short': 'Adh.',
  'progress.kcal': 'Kcal',
  'progress.page': 'Page',
  'progress.of': 'of',
  'progress.prev': 'Previous',
  'progress.next': 'Next',
  'progress.weekly_trend': 'Weekly Trend',
  'progress.no_recent_data': 'No recent data',
  'ai.title': '🤖 AI Nutrition Assistant',
  'ai.toggle_on': '🔴 AI Enabled',
  'ai.toggle_off': '⚪ Quick Mode',
  'ai.analysis_title': '📊 Your Day Analysis',
  'ai.calories': 'Calories',
  'ai.protein': 'Protein',
  'ai.carbs': 'Carbohydrates',
  'ai.fats': 'Fats',
  'ai.missing': 'Missing:',
  'ai.loading': 'Generating personalized suggestions...',
  'ai.recommendations': '💡 Recommendations to Complete Your Goal',
  'ai.portion': 'Recommended portion:',
  'ai.refresh': '🔄 Refresh Suggestions',
  'ai.message_ok': '✅ Great! You already met your goals today',
  'ai.message_quick': '🤖 Suggestions based on analysis (quick mode)',
  'ai.message_generic': '📋 Personalized suggestions',
  'ai.error_loading': '❌ Error loading suggestions',
  'ai.goal_maintenance': 'Maintenance',
  'equivalentes.title': 'Equivalents by Group',
  'equivalentes.subtitle': 'Swap foods while keeping approximate macros.',
  'equivalentes.base': 'Base',
  'equivalentes.error_loading': 'Could not load equivalents. Try later.',
  ...DASHBOARD_I18N_EN,
};
